import { useState, useEffect, useRef } from "react";
import { Spinner, Alert, Button } from "react-bootstrap";
const localstorageKeys=["pStatOpt","pUserOpt","projektstatusOptionen","user"]

export default function ResetOptions({}) {
  return (
    <div className="m-5">
      <Button
      className="m-1"
        onClick={() => {
          const localstorageData=localstorageKeys.map((l_key)=>localStorage.getItem(l_key))
          console.log(localstorageData);
          localStorage.clear();
          localstorageKeys.forEach((l_key,index)=>{localStorage.setItem(l_key,localstorageData[index])})
          // 
          // localStorage.setItem("key", myItem);
        }}
        variant="warning"
      >
        MS Localstorage zurücksetzen
      </Button>
      <Button
      className="m-1"
        onClick={() => {
          localStorage.clear();
        }}
        variant="danger"
      >
        Localstorage komplett zurücksetzen
      </Button>
    </div>
  );
}
